import { HireBenefits } from "./checkout/components/HireBenefits"

export function BookingFooter() {
  return (
    <footer className="booking-footer">
      <div className="booking-footer-inner">
        <HireBenefits className="booking-footer-benefits" />
        <div className="booking-footer-company">
          <p>© 2026 Arctic Hire. All rights reserved.</p>
          <p>Arctic Hire is a trading name of YAT Group Limited.<br />Company registration no. 17241366.</p>
        </div>
        <div className="booking-footer-contact">
          <a href="mailto:contact@arctic-hire.co.uk">contact@arctic-hire.co.uk</a>
          <nav aria-label="Legal">
            <a href="https://www.arctic-hire.co.uk/terms-of-hire" target="_blank" rel="noopener noreferrer">Terms of Hire</a>
            <a href="https://www.arctic-hire.co.uk/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
          </nav>
          <ul className="booking-payment-methods" aria-label="Accepted payment methods">
            {[
              { name: "Visa", file: "visa" },
              { name: "Mastercard", file: "mastercard" },
              { name: "Apple Pay", file: "apple-pay" },
              { name: "Google Pay", file: "google-pay" },
            ].map(({ name, file }) => (
              <li className="booking-payment-method" key={file}>
                <img src={`/payment-logos/${file}.svg`} alt={name} width="48" height="32" />
              </li>
            ))}
          </ul>
        </div>
      </div>
    </footer>
  )
}
